<div class="cet-password-input-container">
  <label for="input{{ label }}" style="margin-bottom: 8px" *ngIf="label">
    {{ label }}
  </label>
  <div
    class="cet-input-group"
    [class.ng-invalid]="control.errors?.['maxlength']|| control.touched&& control.invalid"
    [class.ng-valid]="
      control.valid && !(matchValue && control.value != matchValue)
    "
  >
    <div class="inputGroup form-group " style="padding-bottom: 0px;margin-bottom: 0px;">
      <!--label class="icon" for="input{{ label }}">
        <img src="assets/images/key.svg" alt="password" />
      </label-->
      <input class="form-control"
        [class.login]="login"
        [type]="showPassword ? 'text' : 'password'"
        [id]="ControlId"
        placeholder="{{ placeholder || label }}"
        [formControl]="control" sensitive-data
        (input)="emitValue()"
        (blur)="emitValue()"
        (keydown.enter)="onEnterPressed($event)"
        autocomplete="off"
        [class.ng-valid]="
          control.valid && !(matchValue && control.value != matchValue)
        "
        [class.ng-touched]="control.errors?.['maxlength']"
        style="margin-inline-end: 0px;font-size: 16px;line-height: 1.75rem;min-height: 48px;padding-inline-start: 0px;padding: 11px 20px; border-radius: 0px !important;"
      />
      <span class="icon inputGroup-text" style="min-height: 48px;">
        <img src="assets/images/key.svg" alt="password" />
      </span>
    </div>
    <button (click)="showPassword = !showPassword" type="button">
      <img *ngIf="!showPassword" src="assets/images/eye.webp" alt="password" />
      <img
        *ngIf="showPassword"
        src="assets/images/eye-off.webp"
        alt="password"
      />
    </button>
  </div>
</div>
